import { $_app_server } from '@/_helpers'

export const agreementService = {
  sendAgreements,
  loadAgreements,
  changeEditable,
  removeAgreement,
  downloadSignedAgreement,
  downloadAgreementFile,
  downloadZipAgreements,
  loadMerchWithAgreement
}

let f_resp = (response) => response.data;

function sendAgreements(obj) {
  return $_app_server.post("agreement/sendAgreement", obj).then(f_resp)
}

function loadAgreements(month, year, userId) {
  return $_app_server.get(`agreement/loadAgreements?month=${month}&year=${year}&userId=${userId}`).then(f_resp)
}

function loadMerchWithAgreement(month, year, organizationId) {
  return $_app_server.get(`agreement/loadMerchWithAgreement?month=${month}&year=${year}&organizationId=${organizationId}`).then(f_resp)
}

function changeEditable(agreementId) {
  return $_app_server.post(`agreement/changeEditable?agreementId=${agreementId}`).then(f_resp)
}

function removeAgreement(agreementId) {
  return $_app_server.delete(`agreement/delete/${agreementId}`).then(f_resp)
}

function downloadSignedAgreement(agreementId) {
  return $_app_server.get(`agreement/downloadSignedAgreement?agreementId=${agreementId}`, {
    responseType: 'blob'
  })
}

function downloadAgreementFile(fileUuid) {
  return $_app_server.get(`agreement/checkAgreementFile?fileUuid=${fileUuid}`, {
    responseType: 'blob'
  })
}

function downloadZipAgreements() {
  return $_app_server.get(`agreement/export/zip`, {
    responseType: 'blob'
  })
}